import { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';

interface Particle {
  id: number;
  x: number;
  y: number;
  rotation: number;
  color: string;
}

interface ParticleBurstProps {
  onComplete?: () => void;
}

export function ParticleBurst({ onComplete }: ParticleBurstProps) {
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    const colors = ['#fbbf24', '#f59e0b', '#fb923c', '#f97316', '#fde68a'];
    const newParticles: Particle[] = [];

    for (let i = 0; i < 12; i++) {
      const angle = (i / 12) * 2 * Math.PI;
      const distance = 40 + Math.random() * 20;
      newParticles.push({
        id: i,
        x: Math.cos(angle) * distance,
        y: Math.sin(angle) * distance,
        rotation: Math.random() * 360,
        color: colors[Math.floor(Math.random() * colors.length)]
      });
    }

    setParticles(newParticles);

    const timer = setTimeout(() => {
      if (onComplete) onComplete();
    }, 600);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="absolute inset-0 pointer-events-none flex items-center justify-center">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="absolute animate-particle-burst"
          style={{
            transform: `translate(${particle.x}px, ${particle.y}px) rotate(${particle.rotation}deg)`,
          }}
        >
          <Sparkles
            size={16}
            style={{ color: particle.color }}
            className="drop-shadow-lg"
          />
        </div>
      ))}
    </div>
  );
}
